import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import jsPDF from "jspdf";

function ActNotes() {
    const { url } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const caseData = location.state?.caseData;
    const previousPath = location.state?.from || "/";

    const [paragraphs, setParagraphs] = useState([]);
    const [prev, setPrev] = useState("");
    const [next, setNext] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const getText = async (url) => {
        try {
            const resp = await fetch(`https://bareact-backend-596718606544.us-central1.run.app/extract?url=${url}`);
            const respJson = await resp.json();
            setParagraphs(respJson.paragraphs || []);
            setPrev(respJson.goback || "");
            setNext(respJson.gonext || "");
            console.log(respJson);
        } catch (error) {
            console.error("Error fetching content:", error);
        }
    };

    useEffect(() => {
        getText(url);
    }, [url]);

    const onBack = (url) => getText(url);
    const onNext = (url) => getText(url);

    const highlightText = (text) => {
        if (!searchTerm) return text;
        const regex = new RegExp(`(${searchTerm})`, "gi");
        const parts = text.split(regex);
        return parts.map((part, index) =>
            regex.test(part) ? (
                <mark key={index} className="bg-yellow-300 text-black font-semibold">{part}</mark>
            ) : (
                <span key={index}>{part}</span>
            )
        );
    };

    const downloadPDF = () => {
        const doc = new jsPDF();
        const title = paragraphs[0] || "Notes";
        const body = paragraphs.slice(1).join("\n\n");

        doc.setFontSize(16);
        const margin = 10;
        const lineHeight = 7;
        const pageHeight = doc.internal.pageSize.height;
        let y = margin;

        const titleLines = doc.splitTextToSize(title, 180);
        titleLines.forEach(line => {
            if (y + lineHeight > pageHeight - margin) {
                doc.addPage();
                y = margin;
            }
            doc.text(line, margin, y);
            y += lineHeight;
        });

        y += 4;

        doc.setFontSize(12);
        const bodyLines = doc.splitTextToSize(body, 180);
        bodyLines.forEach(line => {
            if (y + lineHeight > pageHeight - margin) {
                doc.addPage();
                y = margin;
            }
            doc.text(line, margin, y);
            y += lineHeight;
        });

        doc.save(`${title.slice(0, 20)}.pdf`);
    };

    return (
        <div className="min-h-screen bg-[#0c0a29] text-black relative">
            <Navbar />
            <div className="background-circle circle-3 z-0"></div>
            <div className="background-circle circle-4 z-0"></div>

            <main className="px-4 md:px-36 py-8">
                <div className="p-6">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center">
                            <button onClick={() => navigate(-1)} className="text-white">
                                <ArrowLeft />
                            </button>
                            <h1 className="text-xl font-semibold text-yellow-500 ml-4">
                                {paragraphs[0] || "Loading..."}
                            </h1>
                        </div>
                    </div>

                    {/* Search and Download Row */}
                    <div className="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <input
                            type="text"
                            placeholder="Search text..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full sm:w-[30%] p-2 rounded-t-lg border-b border-gray-300 text-white outline-none bg-black"
                        />
                        <button
                            onClick={downloadPDF}
                            className="px-4 py-2 bg-green-600 text-white rounded-lg"
                        >
                            Download PDF
                        </button>
                    </div>

                    {/* Scrollable Paragraph Container */}
                    <div className="bg-white rounded-2xl p-6 max-h-[500px] overflow-y-auto space-y-4 shadow-lg">
                        {paragraphs.slice(1).map((para, index) => (
                            <p key={index} className="text-gray-800 text-base leading-relaxed">
                                {highlightText(para)}
                            </p>
                        ))}
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-between items-center flex-wrap mt-6 gap-4">
                        <div className="flex gap-4">
                            {prev && (
                                <button
                                    className="px-4 py-2 bg-[#FFB800] text-white rounded-lg"
                                    onClick={() => onBack(prev)}
                                >
                                    Prev
                                </button>
                            )}
                            {next && (
                                <button
                                    className="px-4 py-2 bg-[#FFB800] text-white rounded-lg"
                                    onClick={() => onNext(next)}
                                >
                                    Next
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default ActNotes;
